<template>
  <div class="header-container" :class="!visible ? 'header-container-hide' : ''">
    <div class="header-back" @click.stop="backHandle"></div>
    <div class="header-center">{{ title }}</div>
    <div class="header-right">
      <div class="search" @click.stop="showSearch"></div>
    </div>
  </div>
</template>

<script>
/*
  移动端顶部组件
*/
export default {
  name: "myHeader",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    mindMapData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  methods: {
    backHandle() {
      if(this.device.isMobile && this.device.isApp) {
        if(this.device.isIos) {
          if (window.webkit) {
            window.webkit.messageHandlers.jsCallOCFunction.postMessage({
              type: -15,
            });
          }
        }else{
          window.Android.HtmlToAndroid(JSON.stringify({
            type: -15,
          }));
        }
      }else{
        location.href = 'https://ebedit.wenjingketang.com/bookList';
        // this.$router.back()
      }
    },
    showSearch() {
      this.$emit('showSearch')
    },
  }
}
</script>

<style lang="scss" scoped>
.header-container{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 88rem;
  z-index: 999;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24rem 0 20rem;
  transition: top 0.2s linear;
  box-shadow: 0px 3px 8px 0px rgba(32,37,36,0.1);

  .header-back{
    flex: 0 0 44rem;
    width: 44rem;
    height: 44rem;
    background: url("~@/assets/images/common/m/back-icon.png") center center no-repeat;
    background-size: contain;
  }

  .header-center{
    flex: 1;
    font-size: 36rem;
    font-weight: bold;
    color: #333;
    line-height: 88rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    padding: 0 50rem;
  }

  .header-right{
    flex: 0 0 44rem;
    height: 44rem;

    .search{
      width: 44rem;
      height: 44rem;
      background: url("~@/assets/images/common/m/search-icon.png") center center no-repeat;
      background-size: contain;
    }
  }
}

.header-container-hide{
  top: -88rem;
}
</style>